<div class="m-moneyfield"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
    <m-decimalfield v-bind="bindData"
                    v-on="$listeners"
                    :force-rounding-format="true"
                    :precision="precision"
                    :input-aria-label="inputAriaLabel">
        <!-- content should stay inline to avoid adding useless white space -->
        <template v-if="currencyDetail.symbolPosition === 'before'"
                  slot="prefix">
            <span class="m-moneyfield__currency-symbol">
                {{ currencyDetail.localizedSymbol }}
            </span>
        </template>
        <template v-if="currencyDetail.symbolPosition === 'after'"
                  slot="suffix">
            <span class="m-moneyfield__currency-symbol">
                {{ currencyDetail.localizedSymbol }}
            </span>
        </template>
    </m-decimalfield>
</div>
